var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCircleRed = function SvgAlertCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc2c2",
    d: "M11.983 0a12.2 12.2 0 0 0-8.51 3.653A11.8 11.8 0 0 0 0 12.207 11.78 11.78 0 0 0 11.8 24h.214A12.11 12.11 0 0 0 24 11.791 11.766 11.766 0 0 0 11.983 0M10.5 16.542a1.476 1.476 0 0 1 1.449-1.53h.027a1.527 1.527 0 0 1 1.523 1.47 1.475 1.475 0 0 1-1.449 1.53h-.027a1.53 1.53 0 0 1-1.523-1.47M11 12.5v-6a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0"
  })));
};
export default SvgAlertCircleRed;